import { render, staticRenderFns, recyclableRender, components } from "./order-detail.vue?vue&type=template&id=9f310eec&scoped=true&"
var renderjs
import script from "./order-detail.vue?vue&type=script&lang=js&"
export * from "./order-detail.vue?vue&type=script&lang=js&"
import style0 from "./order-detail.vue?vue&type=style&index=0&id=9f310eec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f310eec",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/order/order-detail.vue"
export default component.exports